import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    if (!sid) { navigate("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id: sid });
        localStorage.setItem("authToken", data.token);
        setUser(data.user);
        navigate("/dashboard", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0A0C10] text-slate-300">
      <div className="flex items-center gap-3"><Loader2 className="h-5 w-5 animate-spin text-blue-500" /> {t("auth.connecting")}</div>
    </div>
  );
}
